import React from 'react';
import { Spacer } from './spacer-display.styles.jsx';

const SpacerDisplay = ({ section }) => {
  const height = section?.metadata?.height || '2rem';

  return <Spacer style={{ height }} />;
};

export default SpacerDisplay;